import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const AccessDenied = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  // Classes condicionais para dark mode
  const pageBg = isDarkMode 
    ? 'bg-gradient-to-br from-gray-800 to-gray-900' 
    : 'bg-gradient-to-br from-gray-50 to-gray-100';
  
  const titleColor = isDarkMode ? 'text-gray-100' : 'text-gray-800';
  const textColor = isDarkMode ? 'text-gray-300' : 'text-gray-600';
  
  const buttonClass = `mt-4 text-white px-6 py-2 rounded-lg transition-colors ${
    isDarkMode 
      ? 'bg-blue-500 hover:bg-blue-600' 
      : 'bg-blue-600 hover:bg-blue-700'
  }`;

  return (
    <div className={`min-h-screen flex items-center justify-center ${pageBg}`}>
      <div className="text-center">
        <div className="text-red-500 text-6xl mb-4">⛔</div>
        <h3 className={`text-xl font-semibold mb-2 ${titleColor}`}>Acesso Negado</h3>
        <p className={textColor}>Você não tem permissão para acessar o painel administrativo.</p>
        <button
          onClick={() => navigate('/dashboard')}
          className={buttonClass}
        >
          Voltar para o Dashboard
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;